(() => {
  angular
    .module('app.campaign')
    .controller('CampaignTechedgeController', CampaignTechedge);

    CampaignTechedge.$inject = [
      '$filter',
      'ModalService',
      'EventsService',
      'CampaignService',
      'CampaignManagerService',
    ];

    function CampaignTechedge(
      $filter,
      ModalService,
      EventsService,
      CampaignService,
      CampaignManagerService,
    ) {
      const vm = this;
      vm.isFeatureTechedgeOn = $('#current-user').data('feature-techedge') === 1;
      vm.eventTypes = EventsService.getAllowedEventTypes();

      if (!vm.isFeatureTechedgeOn) {
        vm.snapshotsLoaded = true;
        return false;
      }

      vm.campaign = CampaignManagerService.getCampaignData();
      vm.snapshots = [];

      if (vm.campaign.pid) {
        CampaignService.getCampaignSnapshots({ id: vm.campaign.pid }).$promise
          .then(({ data }) => {
            vm.snapshotsLoaded = true;
            vm.snapshots = [
              ...(data || []).map(item => ({
                ...item,
                createdOn: $filter('timezone')(item.createdOn),
                eventType: vm.eventTypes.find(({ type }) => item.eventType === type),
              })),
              ...CampaignManagerService.getNewSnapshots(),
            ];
          });
      } else {
        vm.snapshotsLoaded = true;
      }

      vm.isStandardCampaign = () => vm.campaign && vm.campaign.type === 'standard';
      vm.hasSnapshots = () => vm.snapshots && vm.snapshots.length !== 0;

      vm.addSnapshot = snapshot => {
        vm.snapshots = [
          ...vm.snapshots,
          {
            ...snapshot,
            eventType: vm.eventTypes.find(({ type }) => snapshot.eventType === type),
            sources: vm.isStandardCampaign() ? snapshot.reportItems : snapshot.sources,
          },
        ];

        CampaignManagerService.addSnapshot(snapshot);
      };

      vm.removeSnapshot = snapshot => {
        vm.snapshots = vm.snapshots.filter(({ id }) => snapshot.id !== id);

        CampaignManagerService.removeSnapshot(snapshot);
      };

      vm.showTechedgeModal = () => {
        ModalService.showModal({
          templateUrl: `/assets/js/app/components/techEdge/techEdge.modal.html?v=${window.BUILD_VERSION}`,
          controller: 'TechEdgeModalController',
          controllerAs: 'techEdgeModal',
          inputs: {
            addSnapshot: vm.addSnapshot,
            saveFromModal: false,
            targetCampaign: vm.campaign,
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            $('#modal-techedge').remove();
            $('.modal-backdrop.fade.in').remove();
          });
        });
      }
    }
})();
